import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  campaign: {
    loading: false,
    data: [],
    error: "",
    init: false,
    processing: false,
    selectedPrediction: {},
    page: 0,
    totalPage: -1,
  },
  category: {
    loading: false,
    data: [],
    error: "",
    init: false,
    processing: false
  },
  candidate: {
    loading: false,
    data: [],
    error: "",
    init: false,
    processing: false
  },
  result: {
    loading: false,
    data: [],
    error: "",
    init: false,
    processing: false
  },
  searchResult: {
    loading: false,
    data: {},
    error: "",
    init: false,
    processing: false
  }
}

const predictionSlice = createSlice({
  name: 'predictionSlice',
  initialState: initialState,
  reducers: {
    setPredictionLoading: (state, action) => {
      state[action.payload].loading = true;
      state[action.payload].error = false;
    },
    setSearchLoading: (state, action) => {
      state.searchResult.loading = false
      state.searchResult.error = ''
    },
    setPredictionSearchProcessing: (state, action) => {
      state.searchResult.processing = action.payload
    },
    setPredictionData: (state, action) => {
      const { error, data, type, page, totalPage } = action.payload;
      if (error?.length > 0) {
        state[type].error = error;
      } else {
        state[type].data = data;
        state[type].init = true;
        if (page && totalPage) {
          state[type].page = page;
          state[type].totalPage = totalPage
        }
      }
      state[type].loading = false;
    },
    setSearchData: (state, action) => {
      const { error, data, type, page, totalPage } = action.payload;
      if (error?.length > 0) {
        state.searchResult.error = error;
      } else {
        state.searchResult.data = data;
        state.searchResult.init = true;
        if (page && totalPage) {
          state.searchResult.page = page;
          state.searchResult.totalPage = totalPage
        }
      }
      state.searchResult.loading = false;
    },
    setPredictionProcessing: (state, action) => {
      const { processing, type } = action.payload
      state[type].processing = processing;
    },
    setSelectedpredictionCampaign: (state, action) => {
      state.campaign.selectedPrediction = action.payload;
    },
    setCampaignPage: (state, action) => {
      state.campaign.page = action.payload;
    },
    resetSearch: (state) => {
      state.searchResult = {...initialState.searchResult}
    },
    tryGetPredictionCampaign: (state, action) => {
      if (action.payload) state.campaign.page = action.payload;
    },
    tryCreatePredictionCampaign: (state, action) => { },
    tryGetPredictionCategoryInfo: (state, action) => { },
    tryCreatePredictionCategory: (state, action) => { },
    tryCreateCandidate: (state, action) => { },
    tryDeleteCandidate: (state, action) => { },
    tryDeletePredictionCategory: (state, action) => { },
    tryUpdateCandidate: (state, action) => { },
    tryUpdatePredictionCategory: (state, action) => { },
    tryUpdatePredictionCampaign: (state, action) => { },
    tryDeletePredictionCampaign: (state, action) => { },
    tryGetCandidates: (state, action) => { },
    tryGetPredictionResult: (state, action) => { },
    tryGetPredictionSearchResult: (state, action) => { },
  },
})

export const {
  tryGetPredictionCampaign,
  tryCreatePredictionCampaign,
  tryGetPredictionCategoryInfo,
  setPredictionLoading,
  setPredictionData,
  setPredictionProcessing,
  setCampaignPage,
  tryCreatePredictionCategory,
  tryCreateCandidate,
  tryDeleteCandidate,
  tryDeletePredictionCategory,
  tryUpdateCandidate,
  tryUpdatePredictionCategory,
  tryDeletePredictionCampaign,
  tryUpdatePredictionCampaign,
  tryGetCandidates,
  setSelectedPredictionCampaign,
  tryGetPredictionResult,
  setSearchData, 
  setSearchLoading,
  setPredictionSearchProcessing,
  tryGetPredictionSearchResult,
  resetSearch
} = predictionSlice.actions

export default predictionSlice.reducer
